import script from "./FeedSummaryCard.vue?vue&type=script&setup=true&lang=js"
export * from "./FeedSummaryCard.vue?vue&type=script&setup=true&lang=js"

import "./FeedSummaryCard.vue?vue&type=style&index=0&id=b319ab6e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b319ab6e"]])

export default __exports__